<template>
  <div class="profile-summary section">
    <h2 class="section-title">
      <span class="icon"><i class="mdi mdi-account"></i></span>
      Professional Summary
    </h2>
    <p class="summary-text">{{ summary }}</p>
  </div>
</template>

<script>
export default {
  name: 'ProfileSummary',
  props: {
    summary: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;

  .icon {
    margin-right: 12px;
    color: $color-primary;
  }
}

.summary-text {
  font-size: 1.05rem;
  line-height: 1.6;
  color: $color-text-muted;
}
</style>